import { COLORS } from '@btime/constants'
import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { PermissionChecker } from '../../session'
import AbsoluteWithMenuSpacePageTemplate from '../../../components/templates/AbsoluteWithMenuSpacePageTemplate'
import Container from '../../../components/structure/Container'
import ControlBar from './ControlBar'
import NonComplianceTable from './table/NonComplianceTable'
import PageHeader from './PageHeader'
import PlaceNonCompliancesLoader from './_load/PlaceNonCompliancesLoader'
import Separator from '../../../components/helpers/Separator'

const PlaceNonComplianceListPage = () => {
  return (
    <AbsoluteWithMenuSpacePageTemplate bgColor={COLORS.white}>
      <PermissionChecker permission="listNonCompliance">
        <Container>
          <FilterHandler tempStorageNamespace="placeNonCompliance" initialState={{ fixedFilterFields: ['statuses'] }}>
            <PageHeader />
            <ControlBar />

            <PlaceNonCompliancesLoader>
              <NonComplianceTable />
            </PlaceNonCompliancesLoader>
          </FilterHandler>
          <Separator weight={32} />
        </Container>
      </PermissionChecker>
    </AbsoluteWithMenuSpacePageTemplate>
  )
}

export default PlaceNonComplianceListPage
